module.exports = __webpack_public_path__ + "img/cat_house.98c1c3bf.png";